// extracted by mini-css-extract-plugin
module.exports = {"matchCentreLayout":"matchCentreLayout_matchCentreLayout__haq2y","condensedHeaderReveal":"matchCentreLayout_condensedHeaderReveal___dyUj"};